<template>
	<c-dialog ref="dialog" width="500" title="自定义编号规则配置" @resolve="submitHandle">
		<c-form ref="form" unit-width="100%">
			<c-input v-model="ruleData.id" type="hidden" name="id"></c-input>
			<c-form-item label="目标表单">
				<c-input v-model="targetForm" disabled></c-input>
			</c-form-item>
			<c-form-item label="编号前缀" width="150">
				<c-input v-model="ruleData.begin_char" name="begin_char" maxlength="5"></c-input>
			</c-form-item>
			<c-form-item label="提交时间">
				<c-radio-group v-model="ruleData.time_format" name="time_format">
					<c-radio value="YYYY">年</c-radio>
					<c-radio value="YYYYMM">年月</c-radio>
					<c-radio value="YYYYMMDD">年月日</c-radio>
				</c-radio-group>
			</c-form-item>
			<c-form-item label="流水号" width="100">
				<c-input v-model="ruleData.seq_length" name="seq_length" type="stepper" stepControls="side" range="1,8" :clear="false" @change="ruleData.seq_length = ruleData.seq_length || 1"></c-input>
			</c-form-item>
			<c-form-item label="标号生成规则">
				<c-input :value="ruleText" disabled></c-input>
			</c-form-item>
			<div class="preview flex-center">
				<label>编号预览</label>
				<p>{{codePreview}}</p>
			</div>
		</c-form>
	</c-dialog>
</template>

<script>
	export default {
		data() {
			return {
				targetForm: '',
				ruleData: {},
				timeFormatOptions: [{
					name: '年',
					value: 'YYYY'
				}, {
					name: '年月',
					value: 'YYYYMM'
				}, {
					name: '年月日',
					value: 'YYYYMMDD'
				}]
			}
		},

		computed: {
			ruleText() {
				let arr = [];
				if (this.ruleData.begin_char && this.ruleData.begin_char.trim()) {
					arr.push(this.ruleData.begin_char.trim());
				}
				if (this.ruleData.time_format) {
					arr.push(this.timeFormatOptions.find(item => item.value == this.ruleData.time_format).name);
				}
				if (this.ruleData.seq_length) {
					arr.push(`${new Array(parseInt(this.ruleData.seq_length)).fill(0).join('')}-${new Array(parseInt(this.ruleData.seq_length)).fill(9).join('')}`);
				}
				return arr.join('+');
			},

			codePreview() {
				let arr = [];
				if (this.ruleData.begin_char && this.ruleData.begin_char.trim()) {
					arr.push(this.ruleData.begin_char.trim());
				}
				if (this.ruleData.time_format) {
					arr.push(new Date().format(this.ruleData.time_format.replace(/Y/g, 'y').replace(/D/g, 'd')));
				}
				if (this.ruleData.seq_length) {
					arr.push(`${new Array(parseInt(this.ruleData.seq_length) - 1).fill(0).join('') + '1'}`);
				}
				return arr.join('');
			}
		},

		methods: {
			open(data) {
				this.targetForm = data.form_type_name;
				this.$refs.form.set(data);
				this.$refs.dialog.open();
			},

			submitHandle(stop, next) {
				stop();
				this.$refs.form.submit({
					url: '/seq/edit',
					success: () => {
						next();
						this.$message({
							message: '保存成功'
						});
						this.$emit('resolve');
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.preview {
		box-sizing: border-box;
		width: 100%;
		height: 50px;
		border: 1px solid var(--unit-border);
		padding: 0 20px;
		overflow: hidden;
		background: #FAFAFA;

		p {
			margin-left: 10px;
			font-size: 24px;
		}
	}
</style>